const getMinimumPurchaseTagValue = ({ tags }) => {
  const defaultMinumPurchaseValue = 0;

  if (!tags) {
    return defaultMinumPurchaseValue;
  }

  const tagsValues = tags.split(',');
  const min_purchase = tagsValues.find(tag =>
    tag.includes('Pedido mínimo (produto)_'),
  );

  if (min_purchase) {
    return Number(min_purchase.split('_')[1]);
  }

  return defaultMinumPurchaseValue;
};

export default getMinimumPurchaseTagValue;
